const dimensionCache = new Map()

export function loadImagePixelDimensions(url, timeoutMs = 15000) {
  const source = String(url || '').trim()
  if (!source) return Promise.resolve('')
  if (dimensionCache.has(source)) return dimensionCache.get(source)

  const pending = new Promise(resolve => {
    const image = new Image()
    let settled = false
    const finish = value => {
      if (settled) return
      settled = true
      window.clearTimeout(timer)
      image.onload = null
      image.onerror = null
      resolve(value)
    }
    const timer = window.setTimeout(() => finish(''), timeoutMs)
    image.onload = () => finish(
      image.naturalWidth && image.naturalHeight
        ? `${image.naturalWidth} × ${image.naturalHeight}`
        : ''
    )
    image.onerror = () => finish('')
    image.src = source
  })

  dimensionCache.set(source, pending)
  return pending
}
